import { render, staticRenderFns } from "./cubage.vue?vue&type=template&id=f428fb22&scoped=true&"
import script from "./cubage.vue?vue&type=script&lang=js&"
export * from "./cubage.vue?vue&type=script&lang=js&"
import style0 from "./cubage.vue?vue&type=style&index=0&id=f428fb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f428fb22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f428fb22')) {
      api.createRecord('f428fb22', component.options)
    } else {
      api.reload('f428fb22', component.options)
    }
    module.hot.accept("./cubage.vue?vue&type=template&id=f428fb22&scoped=true&", function () {
      api.rerender('f428fb22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/cargoDoc/cubage.vue"
export default component.exports